import { render, staticRenderFns } from "./TaxReportingDatabaseForm.vue?vue&type=template&id=838b680e&"
import script from "./TaxReportingDatabaseForm.vue?vue&type=script&lang=js&"
export * from "./TaxReportingDatabaseForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxReportingDatabaseForm.vue?vue&type=style&index=0&id=838b680e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports